import React from 'react';
import {
  Badge,
  Box,
  Button,
  Card,
  CardContent,
  Container,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import BusinessIcon from '@mui/icons-material/Business';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import ReceiptIcon from '@mui/icons-material/Receipt';
import BarChartIcon from '@mui/icons-material/BarChart';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';

const drawerItems = [
  { key: 'home', text: 'Home', icon: <HomeIcon />, opensNotifications: false },
  { key: 'practice', text: 'Practice', icon: <BusinessIcon />, opensNotifications: false },
  { key: 'purchase-kits', text: 'Purchase kits', icon: <AddShoppingCartIcon />, opensNotifications: false },
  { key: 'orders', text: 'Orders', icon: <ReceiptIcon />, opensNotifications: false },
  { key: 'results', text: 'Results', icon: <BarChartIcon />, opensNotifications: false },
  { key: 'notifications', text: 'Notifications', icon: <NotificationsNoneIcon />, opensNotifications: true },
];

const initialNotifications = [
  {
    id: 'NTF-1001',
    subject: 'Lab Results Ready - Eleanor Bishop',
    sentAt: '2026-03-02 09:18',
    unread: true,
    category: 'Results',
    from: 'Veravas Lab Results',
    emailNotified: true,
    firstOpenedAt: null,
    targetType: 'Provider',
    targetLabel: 'Jordan Patel, MD @ Harbor Memory Clinic',
    messageBody:
      'Lab results are ready for Eleanor Bishop. Please review the report and release to chart.',
    pdfUrl: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
  },
  {
    id: 'NTF-1002',
    subject: 'Specimen Delay - Courier Weather Hold',
    sentAt: '2026-03-02 08:52',
    unread: true,
    category: 'Delays',
    from: 'Veravas Operations',
    emailNotified: true,
    firstOpenedAt: null,
    targetType: 'Practice',
    targetLabel: 'Harbor Memory Clinic',
    messageBody: 'A weather event delayed inbound courier pickup for today. Expected delay: 6 hours.',
  },
  {
    id: 'NTF-1003',
    subject: 'Lab Results Ready - Paul Kim',
    sentAt: '2026-03-01 16:07',
    unread: true,
    category: 'Results',
    from: 'Veravas Lab Results',
    emailNotified: true,
    firstOpenedAt: null,
    targetType: 'Provider',
    targetLabel: 'Dana Turner, DO @ Harbor Memory Clinic',
    messageBody:
      'Lab results are ready for Paul Kim. Please review the report and release to chart.',
    pdfUrl: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
  },
  {
    id: 'NTF-1004',
    subject: 'Support Case Follow-up #SC-4821',
    sentAt: '2026-03-01 14:33',
    unread: true,
    category: 'Support',
    from: 'Veravas Support',
    emailNotified: false,
    firstOpenedAt: null,
    targetType: 'Practice',
    targetLabel: 'Harbor Memory Clinic',
    messageBody: 'Support has requested additional context before closing case #SC-4821.',
  },
  {
    id: 'NTF-1005',
    subject: 'Question Response - Collection Procedure Clarification',
    sentAt: '2026-03-01 11:41',
    unread: false,
    category: 'Questions',
    from: 'Veravas Clinical Team',
    emailNotified: true,
    firstOpenedAt: '2026-03-01 12:03',
    targetType: 'Provider',
    targetLabel: 'Jordan Patel, MD @ Harbor Memory Clinic',
    messageBody: 'Clinical team answered your question regarding sample inversion count before shipping.',
  },
  {
    id: 'NTF-1006',
    subject: 'Lab Results Ready - Miriam Cole',
    sentAt: '2026-02-28 17:10',
    unread: false,
    category: 'Results',
    from: 'Veravas Lab Results',
    emailNotified: true,
    firstOpenedAt: '2026-02-28 17:22',
    targetType: 'Provider',
    targetLabel: 'Ari Shah, MD @ Harbor Memory Clinic',
    messageBody: 'Lab results are ready for Miriam Cole. Please review the attached report.',
    pdfUrl: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
  },
  { id: 'NTF-1007', subject: 'Feedback Response - Chain of Custody Notes', sentAt: '2026-02-28 13:24', unread: false, category: 'Feedback', from: 'Veravas QA', emailNotified: false, firstOpenedAt: '2026-02-28 14:05', targetType: 'Practice', targetLabel: 'Harbor Memory Clinic', messageBody: 'QA acknowledged and responded to your chain-of-custody feedback.' },
  { id: 'NTF-1008', subject: 'Lab Results Ready - Noah Diaz', sentAt: '2026-02-27 15:12', unread: false, category: 'Results', from: 'Veravas Lab Results', emailNotified: true, firstOpenedAt: '2026-02-27 15:48', targetType: 'Provider', targetLabel: 'Meera Singh, MD @ Harbor Memory Clinic', messageBody: 'Lab results are ready for Noah Diaz. Please review the attached report.', pdfUrl: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf' },
  { id: 'NTF-1009', subject: 'Turnaround Delay - Instrument Maintenance Window', sentAt: '2026-02-27 10:20', unread: false, category: 'Delays', from: 'Veravas Operations', emailNotified: true, firstOpenedAt: '2026-02-27 10:33', targetType: 'Practice', targetLabel: 'Harbor Memory Clinic', messageBody: 'One analyzer was unavailable for maintenance, adding up to 8 hours to standard turnaround.' },
  { id: 'NTF-1010', subject: 'Support Case Updated #SC-4779', sentAt: '2026-02-26 18:55', unread: false, category: 'Support', from: 'Veravas Support', emailNotified: false, firstOpenedAt: '2026-02-26 19:22', targetType: 'Provider', targetLabel: 'Jordan Patel, MD @ Harbor Memory Clinic', messageBody: 'Support updated case #SC-4779 with final troubleshooting guidance.' },
  { id: 'NTF-1011', subject: 'Lab Results Ready - Ava Lewis', sentAt: '2026-02-26 14:06', unread: false, category: 'Results', from: 'Veravas Lab Results', emailNotified: true, firstOpenedAt: '2026-02-26 14:18', targetType: 'Provider', targetLabel: 'Nina Park, MD @ Harbor Memory Clinic', messageBody: 'Lab results are ready for Ava Lewis. Please review the attached report.', pdfUrl: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf' },
  { id: 'NTF-1012', subject: 'Follow-up Needed - Missing Requisition Signature', sentAt: '2026-02-25 12:37', unread: false, category: 'Follow-up', from: 'Veravas Intake', emailNotified: true, firstOpenedAt: '2026-02-25 13:08', targetType: 'Practice', targetLabel: 'Harbor Memory Clinic', messageBody: 'Please provide updated requisition signature for sample set dated 2026-02-24.' },
  { id: 'NTF-1013', subject: 'Question Response - Result Interpretation Notes', sentAt: '2026-02-25 09:44', unread: false, category: 'Questions', from: 'Veravas Clinical Team', emailNotified: false, firstOpenedAt: '2026-02-25 10:02', targetType: 'Provider', targetLabel: 'Dana Turner, DO @ Harbor Memory Clinic', messageBody: 'Clinical team provided interpretation guidance for your flagged result question.' },
  { id: 'NTF-1014', subject: 'Lab Results Ready - Liam Moore', sentAt: '2026-02-24 16:15', unread: false, category: 'Results', from: 'Veravas Lab Results', emailNotified: true, firstOpenedAt: '2026-02-24 16:51', targetType: 'Provider', targetLabel: 'Ari Shah, MD @ Harbor Memory Clinic', messageBody: 'Lab results are ready for Liam Moore. Please review the attached report.', pdfUrl: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf' },
  { id: 'NTF-1015', subject: 'Support Case Closed #SC-4702', sentAt: '2026-02-24 11:02', unread: false, category: 'Support', from: 'Veravas Support', emailNotified: true, firstOpenedAt: '2026-02-24 11:19', targetType: 'Practice', targetLabel: 'Harbor Memory Clinic', messageBody: 'Support case #SC-4702 has been resolved and closed.' },
];

export default function NotificationsMockHome() {
  const [activeView, setActiveView] = React.useState('home');
  const [activeItem, setActiveItem] = React.useState('home');
  const [notifications, setNotifications] = React.useState(initialNotifications);
  const [searchText, setSearchText] = React.useState('');
  const [statusFilter, setStatusFilter] = React.useState('all');
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(8);
  const [selectedMessage, setSelectedMessage] = React.useState(null);

  const unreadCount = notifications.filter((item) => item.unread).length;

  React.useEffect(() => {
    setPage(0);
  }, [searchText, statusFilter]);

  const filteredNotifications = notifications.filter((item) => {
    const matchesSearch =
      searchText.trim() === '' ||
      `${item.subject} ${item.category} ${item.targetLabel}`.toLowerCase().includes(searchText.trim().toLowerCase());
    const matchesStatus =
      statusFilter === 'all' ||
      (statusFilter === 'unread' && item.unread) ||
      (statusFilter === 'read' && !item.unread);
    return matchesSearch && matchesStatus;
  });
  const pagedNotifications = filteredNotifications.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <Container disableGutters sx={{ mt: 2 }}>
      <Stack direction={{ xs: 'column', md: 'row' }} spacing={2.5} sx={{ maxWidth: 1120, mx: 'auto' }}>
        <Card
          sx={{
            width: { xs: '100%', md: 260 },
            border: '1px solid #d8e2e7',
            boxShadow: 'none',
            borderRadius: 2,
            alignSelf: 'flex-start',
          }}
        >
          <CardContent sx={{ p: 1 }}>
            <List>
              {drawerItems.map((item) => {
                return (
                  <ListItem key={item.key} disablePadding>
                    <ListItemButton
                      selected={activeItem === item.key}
                    onClick={() => {
                      setActiveItem(item.key);
                      if (item.opensNotifications) {
                        setActiveView('notifications');
                        setSelectedMessage(null);
                      } else {
                        setActiveView('home');
                      }
                    }}
                    >
                      <ListItemIcon>
                        {item.key === 'notifications' ? (
                          <Badge badgeContent={unreadCount} color="error">
                            {item.icon}
                          </Badge>
                        ) : (
                          item.icon
                        )}
                      </ListItemIcon>
                      <ListItemText primary={item.text} />
                    </ListItemButton>
                  </ListItem>
                );
              })}
            </List>
          </CardContent>
        </Card>

        <Box sx={{ flex: 1 }}>
          {activeView === 'home' && (
            <Card sx={{ border: '1px solid #d8e2e7', boxShadow: 'none', borderRadius: 3 }}>
              <CardContent sx={{ p: { xs: 3, md: 4 } }}>
                <Typography variant="h4" component="h1" sx={{ mb: 1 }}>
                  Notifications Mock
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Click the Notifications item in the mock drawer to open the main notifications view.
                </Typography>
              </CardContent>
            </Card>
          )}

          {activeView === 'notifications' && (
            <Card sx={{ border: '1px solid #d8e2e7', boxShadow: 'none', borderRadius: 3 }}>
              <CardContent sx={{ p: { xs: 3, md: 4 } }}>
                <Typography variant="h4" component="h1" sx={{ mb: 2 }}>
                  Notifications
                </Typography>
                {!selectedMessage && (
                  <>
                    <Stack direction={{ xs: 'column', md: 'row' }} spacing={1.5} sx={{ mb: 2 }}>
                      <TextField
                        label="Search Notifications"
                        value={searchText}
                        onChange={(event) => setSearchText(event.target.value)}
                        size="small"
                        fullWidth
                      />
                      <TextField
                        select
                        label="Status"
                        value={statusFilter}
                        onChange={(event) => setStatusFilter(event.target.value)}
                        size="small"
                        sx={{ minWidth: 180 }}
                      >
                        <MenuItem value="all">All</MenuItem>
                        <MenuItem value="unread">Unread</MenuItem>
                        <MenuItem value="read">Read</MenuItem>
                      </TextField>
                    </Stack>

                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell>Subject</TableCell>
                          <TableCell>Date</TableCell>
                          <TableCell>Status</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {pagedNotifications.map((item) => (
                          <TableRow
                            key={item.id}
                            hover
                            onClick={() => {
                              if (item.unread) {
                                const openedAt = '2026-03-02 10:14';
                                setNotifications((prev) =>
                                  prev.map((row) =>
                                    row.id === item.id
                                      ? { ...row, unread: false, firstOpenedAt: openedAt }
                                      : row
                                  )
                                );
                                setSelectedMessage({ ...item, unread: false, firstOpenedAt: openedAt });
                              } else {
                                setSelectedMessage(item);
                              }
                            }}
                            sx={{ cursor: 'pointer' }}
                          >
                            <TableCell sx={{ fontWeight: item.unread ? 700 : 400 }}>{item.subject}</TableCell>
                            <TableCell sx={{ fontWeight: item.unread ? 700 : 400 }}>{item.sentAt}</TableCell>
                            <TableCell sx={{ fontWeight: item.unread ? 700 : 400 }}>
                              {item.unread ? 'Unread' : 'Read'}
                            </TableCell>
                          </TableRow>
                        ))}
                        {pagedNotifications.length === 0 && (
                          <TableRow>
                            <TableCell colSpan={3}>
                              <Typography variant="body2" color="text.secondary">
                                No notifications found for current filters.
                              </Typography>
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                    <TablePagination
                      component="div"
                      count={filteredNotifications.length}
                      page={page}
                      onPageChange={(_, newPage) => setPage(newPage)}
                      rowsPerPage={rowsPerPage}
                      onRowsPerPageChange={(event) => {
                        setRowsPerPage(parseInt(event.target.value, 10));
                        setPage(0);
                      }}
                      rowsPerPageOptions={[5, 8, 10, 15]}
                    />
                  </>
                )}

                {selectedMessage && (
                  <Stack spacing={2}>
                    <Card sx={{ border: '1px solid #d8e2e7', boxShadow: 'none', borderRadius: 2 }}>
                      <CardContent sx={{ p: { xs: 2.5, md: 3 } }}>
                        <Stack direction={{ xs: 'column', md: 'row' }} justifyContent="space-between" spacing={1.5}>
                          <Box>
                            <Typography variant="h5">{selectedMessage.subject}</Typography>
                            <Typography variant="body2" color="text.secondary">
                              {selectedMessage.category} Notification
                            </Typography>
                          </Box>
                          <Button variant="text" onClick={() => setSelectedMessage(null)}>
                            Back to Notifications
                          </Button>
                        </Stack>
                      </CardContent>
                    </Card>

                    <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
                      <Card sx={{ border: '1px solid #e5ebef', boxShadow: 'none', borderRadius: 2, flex: 1 }}>
                        <CardContent>
                          <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>
                            Metadata
                          </Typography>
                          <Typography variant="body2"><strong>From:</strong> {selectedMessage.from}</Typography>
                          <Typography variant="body2"><strong>Sent:</strong> {selectedMessage.sentAt}</Typography>
                          <Typography variant="body2">
                            <strong>Email Notified:</strong> {selectedMessage.emailNotified ? 'Yes' : 'No'}
                          </Typography>
                          <Typography variant="body2">
                            <strong>First Opened:</strong> {selectedMessage.firstOpenedAt || 'Not opened yet'}
                          </Typography>
                          <Typography variant="body2">
                            <strong>To:</strong>{' '}
                            {selectedMessage.targetType === 'Practice'
                              ? `${selectedMessage.targetLabel} (Practice-wide)`
                              : `${selectedMessage.targetLabel} (Provider-specific)`}
                          </Typography>
                        </CardContent>
                      </Card>

                      <Card sx={{ border: '1px solid #e5ebef', boxShadow: 'none', borderRadius: 2, flex: 1 }}>
                        <CardContent>
                          <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>
                            Message Body
                          </Typography>
                          <Typography variant="body2">{selectedMessage.messageBody}</Typography>
                          {selectedMessage.category === 'Results' && selectedMessage.pdfUrl && (
                            <Stack direction="row" spacing={1.25} sx={{ mt: 2 }}>
                              <Button
                                component="a"
                                href={selectedMessage.pdfUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                variant="contained"
                                size="small"
                              >
                                View PDF
                              </Button>
                              <Button
                                component="a"
                                href={selectedMessage.pdfUrl}
                                download
                                variant="outlined"
                                size="small"
                              >
                                Download PDF
                              </Button>
                            </Stack>
                          )}
                        </CardContent>
                      </Card>
                    </Stack>
                  </Stack>
                )}
              </CardContent>
            </Card>
          )}
        </Box>
      </Stack>
    </Container>
  );
}
